"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var Classification_helpers_1 = require("../Classification.helpers");
var buildTableHeaderText = function (entryMode, tableHeaderText) {
    if (entryMode) {
        return entryMode === Classification_helpers_1.ClassEntryModeEnum.NavWeight
            ? tableHeaderText !== null && tableHeaderText !== void 0 ? tableHeaderText : null : null;
    }
    return null;
};
var ClassificationTableHeader = function (_a) {
    var entryMode = _a.entryMode, columns = _a.columns, tableHeaderText = _a.tableHeaderText;
    return (react_1.default.createElement(core_1.TableHead, null,
        react_1.default.createElement(core_1.TableRow, null, columns === null || columns === void 0 ? void 0 : columns.map(function (column) {
            return (react_1.default.createElement(StyledTableCell, { style: column.style, colSpan: column.colSpan },
                column.title,
                !column.staticTitle
                    ? buildTableHeaderText(entryMode, tableHeaderText)
                    : undefined));
        }))));
};
exports.default = ClassificationTableHeader;
var StyledTableCell = styled_components_1.default(core_1.TableCell)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    border-bottom: 1px solid black;\n    padding: 0 6px 4px 4px;\n    text-align: right;\n    border-left: 1px solid lightgray;\n    font-size: 12px;\n    width: 10%;\n  }\n"], ["\n  && {\n    border-bottom: 1px solid black;\n    padding: 0 6px 4px 4px;\n    text-align: right;\n    border-left: 1px solid lightgray;\n    font-size: 12px;\n    width: 10%;\n  }\n"])));
var templateObject_1;
